var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-list",
    [
      _c(
        "v-list-group",
        {
          attrs: { "no-action": "", "prepend-icon": "fas fa-tools" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function() {
                return [
                  _c("v-list-item-title", [
                    _vm._v(_vm._s(_vm.$t("global.menu.configurations")))
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "v-list-item",
            { attrs: { link: "", to: { name: "organizationParameters" } } },
            [
              _c(
                "v-list-item-icon",
                [_c("v-icon", [_vm._v("fas fa-boxes")])],
                1
              ),
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", [
                    _vm._v(_vm._s(_vm.$t("global.menu.organizationParameters")))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-list-item",
            { attrs: { link: "", to: { name: "clients" } } },
            [
              _c(
                "v-list-item-icon",
                [_c("v-icon", [_vm._v("fas fa-user")])],
                1
              ),
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", [
                    _vm._v(" " + _vm._s(_vm.$t("global.menu.clients")) + " ")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-list-item",
            { attrs: { link: "", to: { name: "productsTypes" } } },
            [
              _c(
                "v-list-item-icon",
                [_c("v-icon", [_vm._v("fas fa-boxes")])],
                1
              ),
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", [
                    _vm._v(_vm._s(_vm.$t("global.menu.productsTypes")))
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-list-item",
        { attrs: { link: "", to: { name: "purchaseData" } } },
        [
          _c(
            "v-list-item-icon",
            [_c("v-icon", [_vm._v("fas fa-money-check-alt")])],
            1
          ),
          _c(
            "v-list-item-content",
            [
              _c("v-list-item-title", [
                _vm._v(_vm._s(_vm.$t("global.menu.purchaseData")))
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-list-item",
        { attrs: { link: "", to: { name: "statistics" } } },
        [
          _c(
            "v-list-item-icon",
            [_c("v-icon", [_vm._v("fas fa-chart-area")])],
            1
          ),
          _c(
            "v-list-item-content",
            [
              _c("v-list-item-title", [
                _vm._v(_vm._s(_vm.$t("global.menu.statistics")))
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }